const TOKEN_KEY = "gep_token";

function getBase() {
  return typeof window !== "undefined" ? window.location.origin : "";
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export async function api(path, options = {}) {
  const url = path.startsWith("http") ? path : `${getBase()}/api${path}`;
  const headers = { "content-type": "application/json", ...(options.headers || {}) };
  const token = getToken();
  if (token) headers.authorization = `Bearer ${token}`;

  let body = options.body;
  if (body && typeof body !== "string") body = JSON.stringify(body);

  const res = await fetch(url, { ...options, headers, body });

  let data = null;
  const text = await res.text();
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = null;
  }

  if (!res.ok) {
    const message = data?.error?.message || `Request failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    err.details = data?.error?.details;
    throw err;
  }
  return data;
}

export const authApi = {
  login: (email, password) => api("/auth/login", { method: "POST", body: { email, password } }),
  register: (payload) => api("/auth/register", { method: "POST", body: payload }),
  me: () => api("/auth/me"),
};

export const grantsApi = {
  list: (params = "") => api(`/grants${params}`),
  get: (id) => api(`/grants/${id}`),
  create: (payload) => api("/grants", { method: "POST", body: payload }),
  update: (id, payload) => api(`/grants/${id}`, { method: "PUT", body: payload }),
  remove: (id) => api(`/grants/${id}`, { method: "DELETE" }),
};

export const evaluationsApi = {
  list: (params = "") => api(`/evaluations${params}`),
  get: (id) => api(`/evaluations/${id}`),
  create: (payload) => api("/evaluations", { method: "POST", body: payload }),
  update: (id, payload) => api(`/evaluations/${id}`, { method: "PUT", body: payload }),
};

export const statsApi = {
  get: () => api("/stats"),
};

export const usersApi = {
  list: () => api("/users"),
};
